<template lang="html">
  <div>
    <PageHeader :page-title="pageTitle" />
<!--    <SectionHeader v-if="entry.collection.id !== 'tabs' && entry.image" :image="entry.image" />-->
<!--    <Heading v-if="entry.collection.id !== 'tabs'" class="small" v-bind="{label, title: entry.title, subtitle}" />-->
    <slot />
    <hr v-if="entry.collection.id == 'news'">
<!--    <News v-if="entry.collection.id == 'news'" :heading="{title: 'Other news'}" level="h3" :number-of-items="2" />-->
    <PageFooter />

  </div>
</template>

<script>
import dayjs from 'dayjs'

import PageHeader from '@/sections/page-header/PageHeader'
import SectionHeader from '@/sections/section-header/SectionHeader'
import Heading from '@/components/heading/Heading'
import News from '@/sections/section-news/SectionNews'
import PageFooter from '@/components/page-footer/PageFooter'


export default {
  name: 'DetailLayout',
  components: {
    PageHeader,
    SectionHeader,
    PageFooter,
    Heading,
    News
  },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  computed: {
    pageTitle () {
      if(this.entry && this.entry.page_title ) {
        return this.entry.page_title
      }
      return ''
    },
    label() {
      let label
      switch (this.entry.collection.id) {
      case 'news':
        label = dayjs(this.entry.date).format('DD MMMM YYYY')
        break
      case 'event':
        label = 'need to get event date here'
        break
      default: ''
      }
      return label
    },
    subtitle() {
      let subtitle
      switch (this.entry.collection.id) {
      case 'extra-services':
        subtitle = this.entry.price
        break
      default: ''
      }
      return subtitle
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
